import { jsx as _jsx } from "react/jsx-runtime";
/*
SPDX-FileCopyrightText: 2023 Genome Research Ltd.

SPDX-License-Identifier: MIT
*/
import { Row, Col } from "../index";
import { getCssVarValue } from "./utils";
import { themeListener } from "../hooks/listeners";
function Widgets(props) {
    const { components } = props;
    themeListener(() => {
        try {
            const backing = document.getElementById("tol-app-background");
            backing.style.backgroundColor = getCssVarValue("--tol-bg-dark");
        }
        catch {
            return;
        }
    });
    const getSm = (type) => {
        switch (type) {
            case "sm":
                return 6;
            default:
                return 12;
        }
    };
    const getLg = (type) => {
        switch (type) {
            case "sm":
                return 3;
            case "md":
                return 6;
            default:
                return 12;
        }
    };
    const getHeight = (type) => {
        switch (type) {
            case "sm":
                return 150;
            case "md":
                return 450;
            case "lg":
                return 450;
            case "xl":
                return 600;
        }
    };
    const rowStyle = {
        marginLeft: 0,
        marginRight: 0,
        paddingLeft: 0,
        paddingRight: 0,
        marginBottom: -16,
    };
    const colStyle = {
        paddingLeft: 0,
        paddingRight: 0,
    };
    return (_jsx("div", { children: _jsx(Row, { style: rowStyle, children: components.map((item, index) => {
                return (_jsx(Col, { sm: getSm(item.type), lg: getLg(item.type), style: colStyle, children: _jsx("div", { className: "tol-widget", style: { height: getHeight(item.type) }, children: item.component }) }, `tol-widget-${index}`));
            }) }) }));
}
export default Widgets;
